import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { DocumentFolder } from '@/types/document';

export function useDocuments(employeeId: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['documents', employeeId],
    queryFn: async () => {
      const response = await api.get<{ success: boolean; data: DocumentFolder[] }>(
        `/employees/${employeeId}/documents`
      );
      return response.data.data;
    },
    enabled: !!employeeId && (options?.enabled ?? true),
  });
}

async function deleteDocument(employeeId: string, documentId: string): Promise<void> {
  await api.delete(`/documents/${employeeId}/${documentId}`);
}

export function useDeleteDocument(employeeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (documentId: string) => deleteDocument(employeeId, documentId),
    meta: { suppressGlobalToast: true },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents', employeeId] });
    },
  });
}

